import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('selectpg-popup', { static: true }) selectPgPopup: ElementRef
  selectpgPopup: any
  resetPassword: boolean = false
  otpPassword: boolean = false
  showOtp: boolean = false
  otp1: string = ''
  otp2: string = ''
  otp3: string = ''
  otp4: string = ''
  newPassword: boolean = true
  confirmPassword: boolean = true
  Password: boolean = false

  constructor(private elementRef: ElementRef) {}
  ngOnInit(): void {
    this.selectpgPopup = this.elementRef.nativeElement.querySelector('#selectpg-popup')
    this.selectpgPopup.style.display = 'block'
  }
  forgotPassword(): void {
    this.resetPassword = !this.resetPassword
    this.otpPassword = !this.otpPassword
  }

  newPasswordVisibility(): void {
    this.newPassword = !this.newPassword
  }

  confirmPasswordVisibility(): void {
    this.confirmPassword = !this.confirmPassword
  }
}
